import api from './api';

const base = (roomId, leagueId, challengeId) =>
  leagueId
    ? `/api/rooms/${roomId}/leagues/${leagueId}/challenges/${challengeId}/bets`
    : `/api/rooms/${roomId}/challenges/${challengeId}/bets`;

export const getBets = async (roomId, leagueId, challengeId) => {
  const response = await api.get(base(roomId, leagueId, challengeId));
  return response.data;
};

export const getBet = async (roomId, leagueId, challengeId, betId) => {
  const response = await api.get(`${base(roomId, leagueId, challengeId)}/${betId}`);
  return response.data;
};

export const createBet = async (roomId, leagueId, challengeId, data) => {
  const response = await api.post(base(roomId, leagueId, challengeId), data);
  return response.data;
};

export const updateBet = async (roomId, leagueId, challengeId, betId, data) => {
  await api.put(`${base(roomId, leagueId, challengeId)}/${betId}`, data);
};

export const deleteBet = async (roomId, leagueId, challengeId, betId) => {
  await api.delete(`${base(roomId, leagueId, challengeId)}/${betId}`);
};
